const itemsPerPage = 50;

export {
  itemsPerPage,
};

export default itemsPerPage;
